const TRACKED_ATTR = 'data-cp-form-tracked'

type OnFormSubmit = (form: HTMLFormElement) => void

export const initFormTracking = (onFormSubmit: OnFormSubmit): (() => void) => {
  const cleanups: Array<() => void> = []
  let stopped = false

  const stop = (): void => {
    if (stopped) return
    stopped = true
    cleanups.forEach(fn => fn())
    cleanups.length = 0
    observer.disconnect()
  }

  const attachToForm = (form: HTMLFormElement): void => {
    if (form.hasAttribute(TRACKED_ATTR)) return
    form.setAttribute(TRACKED_ATTR, 'true')

    const handler = (): void => onFormSubmit(form)

    form.addEventListener('submit', handler)
    cleanups.push(() => form.removeEventListener('submit', handler))
  }

  const scan = (): void => {
    if (stopped) return
    document.querySelectorAll<HTMLFormElement>('form').forEach(attachToForm)
  }

  const observer = new MutationObserver(mutations => {
    if (stopped) return
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue
        if (node instanceof HTMLFormElement) {
          attachToForm(node)
        } else {
          node.querySelectorAll<HTMLFormElement>('form').forEach(attachToForm)
        }
      }
    }
  })

  scan()
  observer.observe(document.body, { childList: true, subtree: true })

  return stop
}
